import axios, { AxiosInstance } from 'axios';
import qs from 'qs';
import { injectable } from 'inversify';
import { receiveClientTrackingId } from './helper';
import LogApi from './LogApi';
import MetricsApi from './MetricsApi';

@injectable()
export default class AnalyticsApiClient {
  private readonly api: AxiosInstance;

  private readonly logApi: LogApi;

  private readonly metricsApi: MetricsApi;

  constructor(baseUrl: string) {
    this.api = axios.create({
      baseURL: baseUrl,
      timeout: 10_000,
      withCredentials: true,
      paramsSerializer: (params) => qs.stringify(params),
      headers: {
        'x-cl-id': receiveClientTrackingId(),
      },
    });

    this.api.defaults.headers.common['Cache-Control'] = 'no-cache';
    this.api.defaults.headers.common.Pragma = 'no-cache';
    this.api.defaults.headers.common.Expires = '0';

    this.logApi = new LogApi(this.api);
    this.metricsApi = new MetricsApi(this.api);
  }

  get log(): LogApi {
    return this.logApi;
  }

  get metrics(): MetricsApi {
    return this.metricsApi;
  }
}
